export default __webpack_public_path__ + "static/media/sweet_earth_texture.be6b5d0f.jpg";